import { WorkBook } from 'xlsx';
import { ISheetRow } from './ISheetRow';
export interface ISheet {
    rows: ISheetRow[];
    name: string;
    rawWorkbook: WorkBook;
}
